<template>
  <div class="container mx-auto px-10">
    <div class="bg-white rounded-lg shadow-lg overflow-hidden">
      <div class="p-6">
        <div class="space-y-4">
          <div
            v-for="invoice in props.invoices"
            :key="invoice.OrderId"
            class="border-b border-gray-200 pb-4 last:border-b-0"
          >
            <div class="flex items-center justify-between">
              <div>
                <h3 class="text-lg font-medium">
                  Fatura No: {{ invoice.OrderId }}
                </h3>
                <div class="mt-2 space-y-1">
                  <p class="text-gray-600">
                    Tutar: {{ invoice.TotalAmount.toLocaleString("tr-TR") }} TRY
                  </p>
                  <p class="text-gray-600">
                    Kart: **** **** **** {{ invoice.LastFourDigit }}
                  </p>
                  <div class="mt-1">
                    <span
                      v-if="invoice.OrderStatus === 'SUCCESSFUL_PAYMENT'"
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
                    >
                      Ödendi
                    </span>
                  </div>
                </div>
              </div>

              <div class="text-right">
                <div
                  v-if="invoice.IsInvoiceCreated && invoice.InvoiceUrl"
                  class="space-y-2"
                >
                  <p class="text-sm text-gray-600">
                    Fatura Tarihi: {{ invoice.InvoiceDate }}
                  </p>
                  <a
                    :href="invoice.InvoiceUrl"
                    class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  >
                    <i class="fas fa-download mr-2"></i>
                    Faturayı İndir
                  </a>
                </div>
                <div v-else class="text-sm text-gray-500 italic">
                  Fatura henüz oluşturulmadı. Bu işlem 7 iş günü alabilir.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
const props = defineProps({
  invoices: {
    type: Array,
    required: true,
  },
});
</script>
